import {Invoice} from '../invoice';

export function toString(this: Invoice) {
    return `Deal: ${this.id}`;
}
